/**
 * Documentation written by: ChatGPT - Henrik
 * This file defines a constant array of currency options for use in dropdowns or selectors.
 * Each currency option includes a `label` for display purposes and a `value` for internal use.
 *
 * - `label`: The display name of the currency (e.g., "Grunnbeløp", "Norske kroner").
 * - `value`: The internal representation or code for the currency (e.g., "G", "NOK").
 *
 * Example Usage:
 * - Display these options in a dropdown menu for currency selection.
 * - Retrieve the selected currency using its `value`.
 */

export const currencyOptions = [
	{ label: "currency.G", value: "G" },
	{ label: "currency.NOK", value: "NOK" },
] as const;
